import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tooltip } from '@material-ui/core';
import { EntityAuditTooltip } from 'components/EntityAudit/EntityAuditTooltip';
import NotificationProvider from 'components/NotificationProvider';
import { selectIsClient } from 'features/user/userSlice';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NoteContent } from './NoteContent';
import { useAddNoteMutation, useEditNoteMutation, useAddHotNoteMutation, useEditHotNoteMutation } from './notesSlice';

const NoteEditor = ({
    note,
    onClose,
    onSaved,
    withDialog = true,
    hideViewByClient,
    maxLength = null,
    suppressSuccessToast = false,
}) => {
    const isClient = useSelector(selectIsClient);
    const [changed, setChanged] = useState(false);
    const [saving, setSaving] = useState(false);
    const [noteToEdit, setNoteToEdit] = useState({ viewByClient: isClient ? true : false });
    const plainTextLength = (noteToEdit.content ?? '').replace(/<[^>]*>/g, '').length;
    const isOverLimit = maxLength !== null && plainTextLength > maxLength;
    const [addNote] = useAddNoteMutation();
    const [saveNote] = useEditNoteMutation();
    const [addHotNote] = useAddHotNoteMutation();
    const [editHotNote] = useEditHotNoteMutation();

    useEffect(() => {
        setNoteToEdit({ ...noteToEdit, ...note });
    }, [note]);

    const onChange = (field, value) => {
        setNoteToEdit({ ...noteToEdit, [field]: value });
    }

    const onSave = async () => {
        setSaving(true);
        let res;
        noteToEdit.showInReport = !noteToEdit.viewByClient ? false : noteToEdit.showInReport;
        if (noteToEdit.id) {
            res = await (noteToEdit.isHotNote ? editHotNote : saveNote)(noteToEdit);
        } else {
            res = await (noteToEdit.isHotNote ? addHotNote : addNote)(noteToEdit);
        }
        if (res.error) {
            NotificationProvider.error('Failed to save the note');
        } else {
            if (!suppressSuccessToast) {
                NotificationProvider.success('Successfully save the note');
            }
            onSaved?.();
            onClose();
        }
        setSaving(false)
    }
    const noteContent = <NoteContent
        content={noteToEdit.content}
        viewByClient={noteToEdit?.viewByClient}
        onChange={onChange}
        showInReport={noteToEdit?.showInReport}
        entityType={noteToEdit.entityType}
        hideViewByClient={hideViewByClient}
        maxLength={maxLength}
        plainTextLength={plainTextLength}
    />

    const buttons = <><Button onClick={() => onClose()} >
        Cancel
    </Button>
        <Tooltip title={isOverLimit ? `Note exceeds the ${maxLength} character limit` : ''}>
            <span>
                <Button disabled={saving || isOverLimit} onClick={onSave} variant="contained" color='primary'>
                    {saving ? 'Saving...' : 'Save'}
                </Button>
            </span>
        </Tooltip></>

    return (
        <> {withDialog ?
            <Dialog open={true} onClose={onClose}>
                <DialogTitle>
                    {note?.id ? 'Edit Note' : 'Add Note'}
                    {note?.id && <EntityAuditTooltip entity={note} />}
                </DialogTitle>
                <DialogContent>
                    {noteContent}
                </DialogContent>
                <DialogActions>
                    {buttons}
                </DialogActions>
            </Dialog>
            : <Grid container direction='column'>
                <Grid item>
                    {noteContent}
                </Grid>
                <Grid container style={{ justifyContent: 'end' }}>
                    {buttons}
                </Grid>
            </Grid>
        } </>
    );
}
export default NoteEditor;
